<template>
    <c-modal
        v-model="modal"
        size="md"
        centered
        :tag="false"
        title="Add New Category"
        confirm-label="Save"
        cancel-label="Cancel"
        :progressing="progressing"
        @show="showModal"
        @submit="submit"
    >
        <template>
            <b-container fluid class="px-0">
                <b-row>
                    <b-col cols="12">
                        <b-form-group>
                            <b-input-group prepend="Category Name">
                                <b-input placeholder="Required" class="myFeild" name="Category Name" v-model="model.CategoryDESC" v-validate="'required'"/>
                            </b-input-group>
                        </b-form-group>

                        <b-form-group>
                            <b-input-group prepend="Category Comments">
                                <b-textarea placeholder="Optional" class="myFeild" name="Category Comments" v-model="model.CategoryComment"/>
                            </b-input-group>
                        </b-form-group>

<!--                        <b-form-group>-->
<!--                            <b-input-group prepend="Displaystation">-->
<!--                                <b-select name="Displaystation"v-validate="'required'" v-model="model.kds" value-field="KDSID" text-field="KDS" :options="kds"/>-->
<!--                            </b-input-group>-->
<!--                        </b-form-group>-->

<!--                        <b-form-group>-->
<!--                            <b-input-group prepend="Printstation">-->
<!--                                <b-select name="Printstation" v-model="model.Printstation" value-field="PrinterID" text-field="PrinterName" :options="printStation"/>-->
<!--                            </b-input-group>-->
<!--                        </b-form-group>-->
                    <b-input-group prepend="Menu Board TV Name" v-if="HasTV" class="mt-2">
                        <b-form-select
                            class="myFeild"
                            v-model="selectedTV"
                            :options="TVs"
                            placeholder="Select"
                            >
                            <template #first>
                                <b-form-select-option :value="null || ''">Select...</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-input-group>
                    <b-input-group v-if="HasTV" prepend="Category Name Spacing - Before (Lines)" class="mt-2">
                        <b-input
                            type="number"
                            class="myFeild"
                            v-model="NumOfLines" 
                            placeholder="Optional"
                            min="0"
                            @input="NumOfLines = Math.max(0, NumOfLines)"
                        />
                    </b-input-group>
                    </b-col>

                    <b-col cols="12">
                        <b-alert :show="errors.any()" variant="danger" class="px-4 my-2">
                            <ul class="m-0 px-1">
                                <li v-for="err in errors.all()" :key="err">{{err}}</li>
                            </ul>
                        </b-alert>
                    </b-col>
                </b-row>
            </b-container>
        </template>
    </c-modal>
</template>

<script>
import CModal from "../../../shared/Cmodal";
    export default {
        name: "createCategory",
        components: {CModal},
        props: {
            value: {required: true, type: Boolean, default: false},
            currentMenuType: {
                required: false
            },
            edibleType: {
                required: true,
                type: String
            }
        },
        data () {
            return {
                progressing: false,
                selectedTV:"",
                TVs:[],
                TVrereferences:[],
                NumOfLines:0,
                model: {
                    CategoryDESC: '',
                    CategoryComment: '',
                    Printstation: 'None',
                    kds: '',
                    EdibleType: this.edibleType,
                    RestaurantID: this.$store.state.selectedRestaurantId
                },
                kds: [],
                printStation: [],
                HasTV:localStorage.getItem("hasMenuboard")=== "true"
            }
        },
        computed: {
            modal: {
                get () {
                    return this.value
                },
                set (val) {
                    this.$emit('input', val)
                }
            }
        },
        methods: {
            showModal () {
                this.HasTV = localStorage.getItem("hasMenuboard") === "true"
                this.model.CategoryDESC = ''
                this.model.CategoryComment = ''
                Promise.all([
                    this.getKds(),
                    this.getPrintStation(),
                    this.getRestaurantTVs()
                ]).then(res => {
                    this.kds = res[0]
                    if (this.kds.length) {
                        this.model.kds = this.kds[0].KDSID
                    }
                    this.printStation = [{PrinterName: 'None', PrinterID: 'None'}, ...res[1]]
                })
            },
            getPrintStation () {
                let object = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                }
                return this.$api.getRestaurant.GetRestaurantPrinters(object).then(res => {
                    if (res.success) {
                        return res.results.RestaurantPrinter
                    } else {
                        this.$showError(res.message)
                    }
                })
            },
            getRestaurantTVs(){
                let object = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    TVid:-1
                }
                return this.$api.getRestaurant.GetRestaurantMenuboardTVs(object).then(res=>{
                    if(res.success){
                        this.TVs = res.menuBoards.map(tv => tv.TVname)
                        this.TVrereferences = res.menuBoards
                        this.NumOfLines = 0
                    }
                    
                })

            },
            getKds () {
                let object = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                }
                return this.$api.getRestaurant.GetRestaurantKDSs(object).then(res => {
                    if (res.success) {
                        return res.results.RestaurantKDS
                    } else {
                        this.$showError(res.message)
                    }
                }).catch(() => {

                })
            },

            submit () {
                this.model.EdibleType = this.edibleType 
                this.$validator.validateAll().then(proceed => {
                    if (proceed) {
                        const model = {...this.model}
                        model.CategoryPreSpacing = this.NumOfLines
                        model.MenuTypeID = this.currentMenuType.MenuTypeID
                        this.progressing = true
                        return this.$api.category.create(model).then((res) => {
                            if(this.selectedTV != "" && this.selectedTV != null){
                                let foundTV = this.TVrereferences.find(tv => tv.TVname === this.selectedTV)
                                let model2 = {
                                    RestaurantID: this.$store.state.selectedRestaurantId,
                                    EdibleType: this.edibleType,
                                    ShowOnTV: foundTV.TVid
                                }
                                return this.$api.category.UpdateMenuboardTVByCategory(model2, res.response).then(()=>{
                                    this.progressing = false
                                this.modal = false
                                this.$emit('refresh', this.currentMenuType)
                                })
                            }else{
                                this.progressing = false
                                this.modal = false
                                this.$emit('refresh', this.currentMenuType)
                            }
                        }).catch((err) => {
                            this.progressing = false
                            console.log(err)
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
